module.exports = __webpack_public_path__ + "img/NGNL1.caf30f09.jpg";